import { useReactiveVar } from '@apollo/client/react';
import { fetchAuthSession } from '@aws-amplify/auth';
import { useMsal } from '@azure/msal-react';
import { useCallback } from 'react';
import { graphqlTokenVar, tenantsServiceTokenVar } from 'state/vars';
import { getMsalToken } from 'utils/MsalToken/msalToken';

/*
 * Centralizes the logic to dynamically fetch the right token on demand based on the current auth mode
 */
const useGraphQLAuthToken = () => {
  const { tokenType } = useReactiveVar(graphqlTokenVar);
  const { accounts, instance } = useMsal();
  const [loggedAccount] = accounts;
  const tenantToken = useReactiveVar(tenantsServiceTokenVar);

  const getToken = useCallback(async (): Promise<string> => {
    switch (tokenType) {
      case 'COGNITO': {
        const session = await fetchAuthSession();
        return session.tokens?.accessToken?.toString() ?? '';
      }

      case 'ENTRA': {
        if (!loggedAccount) return '';
        const result = await getMsalToken(loggedAccount, instance);
        if (!result.accessToken || result.accessToken === 'no-token') return '';
        return result.accessToken;
      }

      case 'TENANT':
        return tenantToken ?? '';

      default:
        return '';
    }
  }, [tokenType, loggedAccount, instance, tenantToken]);

  return getToken;
};

export default useGraphQLAuthToken;
